'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _FormInput = require('./FormInput');

var _FormInput2 = _interopRequireDefault(_FormInput);

require('./PasswordInput.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Creates an input field for a password which can be switched between hidden and shown.
 */
var PasswordInput = function (_React$Component) {
    _inherits(PasswordInput, _React$Component);

    function PasswordInput(props) {
        _classCallCheck(this, PasswordInput);

        var _this = _possibleConstructorReturn(this, (PasswordInput.__proto__ || Object.getPrototypeOf(PasswordInput)).call(this, props));

        _this.state = {
            isVisible: false
        };

        _this.toggleVisibility = _this.toggleVisibility.bind(_this);
        _this.getVisiblePasswordInput = _this.getVisiblePasswordInput.bind(_this);
        _this.getHiddenPasswordInput = _this.getHiddenPasswordInput.bind(_this);
        return _this;
    }

    _createClass(PasswordInput, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.state.isVisible !== prevState.isVisible) {
                this.refs.password.focus();
            }
        }
    }, {
        key: 'getVisiblePasswordInput',
        value: function getVisiblePasswordInput() {
            return _react2.default.createElement(
                'div',
                { className: 'field-row' },
                _react2.default.createElement(
                    'div',
                    { className: 'field PasswordInput' },
                    _react2.default.createElement(_FormInput2.default, _extends({}, this.props, { ref: 'password', type: 'text', className: 'password-input' })),
                    _react2.default.createElement('input', { type: 'button', className: 'password-visibility-button', onClick: this.toggleVisibility,
                        value: 'Hide' })
                )
            );
        }
    }, {
        key: 'getHiddenPasswordInput',
        value: function getHiddenPasswordInput() {
            var canShowPassword = this.props.canShowPassword;

            var classes = (0, _classnames2.default)('field PasswordInput', { 'has-show-button': canShowPassword });
            return _react2.default.createElement(
                'div',
                { className: 'field-row' },
                _react2.default.createElement(
                    'div',
                    { className: classes },
                    _react2.default.createElement(_FormInput2.default, _extends({}, this.props, { ref: 'password', type: 'password', className: 'password-input' })),
                    canShowPassword ? _react2.default.createElement('input', { type: 'button', className: 'password-visibility-button', onClick: this.toggleVisibility,
                        value: 'Show' }) : null
                )
            );
        }
    }, {
        key: 'toggleVisibility',
        value: function toggleVisibility(event) {
            event.preventDefault();

            this.setState({
                isVisible: !this.state.isVisible
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var canShowPassword = this.props.canShowPassword;
            var isVisible = this.state.isVisible;

            return canShowPassword && isVisible ? this.getVisiblePasswordInput() : this.getHiddenPasswordInput();
        }
    }]);

    return PasswordInput;
}(_react2.default.Component);

PasswordInput.propTypes = {
    name: _propTypes2.default.string.isRequired,
    canShowPassword: _propTypes2.default.bool
};

exports.default = PasswordInput;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/form/fields/PasswordInput.js
// module id = 433
// module chunks = 0